<template>
  <div class="errPage-container">
    <el-row>
      <el-col :span="24">
        <h2>你没有权限去该页面</h2>
        <h6>如有需要请联系你领导</h6>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'Page401',
  data() {
    return {

    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .errPage-container {
    width: 1000px;
    max-width: 100%;
    margin: 100px auto;
    padding: 10px;
    background: #fff;
    .pan-back-btn {
      background: #008489;
      color: #fff;
      border: none!important;
    }
    .pan-gif {
      margin: 0 auto;
      display: block;
    }
    .pan-img {
      display: block;
      margin: 0 auto;
      width: 100%;
    }
    .text-jumbo {
      font-size: 60px;
      font-weight: 700;
      color: #484848;
    }
    .list-unstyled {
      font-size: 14px;
      li {
        padding-bottom: 5px;
      }
      a {
        color: #008489;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>
